document.addEventListener("DOMContentLoaded", function () {

    var videoElement = document.querySelector('.video_slider');
    if(videoElement){
    var video = new Splide( '.video_slider', {
        type   : 'loop',
        perPage: 4,
        perMove: 1, 
        autoplay: true,
        pagination: false,
        arrows: false, 
        speed: 1200,
        gap: "20px",
        breakpoints: {
        767: { 
            perPage: 1,
            perMove: 1,
        },
        },
    });
    
    video.mount();
    }

});